<template>
  <App >
    <AppBar style="flex-grow:1;position:fixed;top:0;right:0;width:50%;;z-index:101;background:none;" :closable="false">
        <div class="flex-wrap">
       
      </div>
        <div>
          <AppAvatar v-if="uid" />
        </div>
    </AppBar>
    <AppMask title="任吾行 — 表单设计器" iconRight="table" :loading="!is_ready" >
      <div v-if="uid" style="font-size:16px;font-weight:bold;color:var(--primary)">系统登录中,请稍后</div>
    </AppMask>
    <BaseLoadingModal v-if="is_ready" :value="loading" title="正在加载表单" />

    <AppClient  class="flex-wrap" style="align-items:stretch;top:0;">
      <keep-alive>
        <template v-if="formView=='editor'">
          <FormEditor
            ref="editor"
            v-model="form"
            style="height:100%"
            @on-event="handleEvent"
          />
        </template>
      </keep-alive>
    </AppClient>

  </App>
</template>

<script>
import responsableMixin from '@/mixins/responsable';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppAvatar from '@/components/app/avatar';
import AppMask from '@/components/app/mask-loading';
import AppClient from '@/components/app/client';
import IconButton from '@/components/app/IconButton';
import IconTabs from '@/components/app/IconTabs';
import FormEditor from '@/components/form/zzl/ind_editor';
export default {
  components:
  {
    App,
    AppBar,
    AppMask, AppClient, IconButton, IconTabs, FormEditor, AppAvatar
  },
  data() {
    return {
      formView: 'editor',
      loading: false,
      is_ready: false,
      uid: null,
      form: {
        id: 'create',
        name: '新建表单',
        config: {
          labelPosition: 'top',
          labelWidth: 400,
        },
        fields: [],
      },
    };
  },
  mixins: [responsableMixin],
  mounted() {
    if (this.$route.query.fID) {
      this.getFormData(this.$route.query.fID);
    }
  },
  watch: {
    $route: {
      handler(v) {
        const {uid, fID} = v.query;
        if (uid) {
          this.uid = uid;
          this.Login(uid);
          console.log('login')
          if (fID) {
            this.getFormData(fID);
          } else {
            this.initEmptyForm();
          }
        } else {
          this.is_ready = true;
          this.initEmptyForm();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleEvent(e) {
      if (e.type == 'refresh') {
        this.getFormData(this.$route.query.fID);
      }
    },
    initEmptyForm() {
      this.form = {
        id: 'create',
        name: '新建表单',
        type: '临时表单',
        config: {
          labelPosition: 'top',
          labelWidth: 400,
        },
        fields: [],
      };
    },
    Login(uid) {
      this.is_ready = false;
      this.$store.dispatch('session/login_zzl', {uid}).then((res)=>{
       
      }).catch((e)=>{
        console.log('login error', e)
        this.Error('登录失败,启用离线模式');
      }).finally(()=>{
        this.is_ready = true;
      });
    },
    getFormData(id) {
      if(this.timer)
        return
      this.timer = setTimeout(()=>{
        this.$api.afterLogin(()=>{
          this.loading = true;
          this.$api.get('logined_zzl/form?id='+id).then((res)=>{
            const formData = res.data.data;
            if (this.$refs.editor) {
              if (!formData.jsd) {
                formData.jsd = {};
              }
              formData.jsd.fID = formData.fID;
              formData.jsd.formCode = formData.formCode;
              formData.jsd.formName = formData.formName;
              const form = this.$refs.editor.transform(formData.jsd);
              this.form = form;
            }
          }).catch((e)=>{
            this.Error(e);
          }).finally(()=>{
            setTimeout(()=>{
              this.loading = false;
            }, 500);
          });
        });
      },1000);
    },
  },
  computed: {
    menus() {
      const def_items = [{
        icon: 'edit',
        name: '表单设计',
        key: 'editor',
      },
      ];
      const items = [...def_items];
      return items;
    },
  },
};
</script>

<style>

</style>
